import axios from "axios";
import { ImmunisationClearCertificateModel, parseImmunisationClearCertificateModel } from "@teamprevent/common/immunisation/models";

const viewImmsClearance = (ohCaseId: string, taskId: string) => {
    axios.post(`/api/ohCase/${ohCaseId}/task/${taskId}/viewImmsClearance`);
};

const getImmunisationClearCertificateDetails = async (employeeRecordId: string, ohCaseId: string, taskId: string) => {
    const response = await axios.get<ImmunisationClearCertificateModel>(
        `/api/employeeRecord/${employeeRecordId}/ohCase/${ohCaseId}/task/${taskId}/immunisationClearCertificate`);
    return parseImmunisationClearCertificateModel(response.data);
};

export const immunisationApi = { viewImmsClearance, getImmunisationClearCertificateDetails };
